import { render } from "./AppointmentsTableItems.vue?vue&type=template&id=ddc7b1f4"
import script from "./AppointmentsTableItems.vue?vue&type=script&lang=js"
export * from "./AppointmentsTableItems.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/nuxt-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__